export default "__VITE_ASSET__Cxuvjygw__"